export enum RCAUploadTypeEnum {
    "DOCUMENT" = "document",
    "MEDIA" = "media",
    "ALL" = "all",
}
export interface IRCAUploadZone {
    uploadType: RCAUploadTypeEnum;
}
